import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"max-height":"700px","overflow-y":"auto"} }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_4 = { style: {"max-height":"700px","overflow-y":"auto"} }
const _hoisted_5 = { class: "footer" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalTableConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import dayjs from 'dayjs'
import {
  postData,
  downloadData,
  getListData
} from '@/service/main/system'
import { ElLoading, ElMessage, ElMessageBox  } from 'element-plus'
import PageContent from '@/components/PageContent.vue'
import { usePageModalTable } from '@/hooks/usePageModalTable'
import { reactive, ref } from 'vue'

interface Cust {
  avatar: string
  nickName: string
  corpName: string
  wxAccount: string
  empName: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceManage',
  setup(__props) {

initEmptyParam()
const store = useStore()

const queryParam = {
  timeSlot: [
    dayjs().subtract(0, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().subtract(0, 'day').endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)

let loadingInstance = ref<InstanceType<typeof ElLoading>>()
const handleImportProgress = (res: any) => {
  loadingInstance = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
const handleImportSuccess = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance) {
    loadingInstance.close(); // 关闭Loading实例
  }
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join('；')
    ElMessage({
      type: 'error',
      duration: 0,
      showClose: true,
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    if(res && res.code){
      ElMessage({
        type: 'warning',
        message: res.message
      })
    }else{
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
      handleSearchClick(queryParam)
    }
  }
}
const handleImportError = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance) {
    loadingInstance.close(); // 关闭Loading实例
  }
  ElMessage({
    type: 'error',
    message: res.message
  })
}

const handleDownloadImport = () => {
  const fileName = '电话资源导入模板.xlsx'
  downloadData(
    '/main/phoneResource/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const resetCb = () => {
  return queryParam
}
const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)
// const [
//   pageModalTableRef,
//   defaultTableInfo,
//   dataList,
//   handleViewClick,
//   dataCount
// ] = usePageModalTable()

const linkCustFlag = ref(false)
const hisListFlag = ref(false)
const configPhoneResourceId = ref('')
const viewCustomPhone = ref('')
const page = ref({ pageNo: 1, pageSize: 5 })
const page1 = ref({ pageNo: 1, pageSize: 10 })
const custItems = ref([])
const listCount = ref(0)
const dataList = ref([])
const dataCount = ref(0)
const currentRow = ref()
const queryCustList = (item: any) => {
  getListData('/main/phoneResource/queryCustList', {
    pageNo: page.value.pageNo,
    pageSize: page.value.pageSize,
    custName: formInline.nickName
  }).then((res) => {
    custItems.value = res.list
    listCount.value = Number(res.total)
    // 解绑事件时关闭Loading
    if (loadingInstance) {
      loadingInstance.close(); // 关闭Loading实例
    }
    tipFlag.value = true
  })
}
const handleViewClick = (item: any) => {
  getListData('/main/phoneResource/queryHisList', {
    pageNo: page1.value.pageNo,
    pageSize: page1.value.pageSize,
    id: item.id
  }).then((res) => {
    dataList.value = res.list
    dataCount.value = Number(res.total)
    hisListFlag.value = true
  })
}
const handleConfigUnionIdClick = (item: any) => {
  configPhoneResourceId.value = item.id
  linkCustFlag.value = true
}
const handleCurrentChange = (val: Cust | undefined) => {
  ElMessageBox.confirm('确定关联这个客户吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    // 用户确认后执行
    currentRow.value = val
    postData(
      '/main/phoneResource/linkCust',
      {
        id: configPhoneResourceId.value,
        userId: currentRow.value.userId,
        unionId: currentRow.value.unionId,
        nickName: currentRow.value.nickName,
        corpId: currentRow.value.corpId,
        corpName: currentRow.value.corpName
      }
    ).then((res) => {
      ElMessage({
        type: 'success',
        message: '关联客户信息成功'
      })
    })
  }).catch(() => {
    // 取消操作
  })
}
const handleSizeChange = (pageSize: number) => {
  page.value.pageSize = pageSize
  queryCustList({})
}
const handleCurrentPageChange = (pageNo: number) => {
  page.value.pageNo = pageNo
  queryCustList({})
}
const formInline = reactive({
  nickName: ''
})
const tipFlag = ref(false)
const onSubmit = () => {
  loadingInstance = ElLoading.service({
    lock: true,
    text: '查询数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  queryCustList({})
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "phoneResource",
        downFilename: "电话资源.xlsx",
        onDownBtnClick: _unref(handleDownBtnClick),
        onYbwaveDownloadImport: handleDownloadImport,
        onImportProgress: handleImportProgress,
        onImportSuccess: handleImportSuccess,
        onImportError: handleImportError,
        onConfigUnionIdClick: handleConfigUnionIdClick,
        onViewClick: handleViewClick
      }, null, 8, ["contentTableConfig", "onDownBtnClick"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: hisListFlag.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hisListFlag).value = $event)),
      width: "500",
      top: "1%",
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_table, {
            data: dataList.value,
            "highlight-current-row": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "渠道来源",
                property: "sourceChannel"
              }),
              _createVNode(_component_el_table_column, {
                label: "归属组别",
                property: "vestDeptName"
              }),
              _createVNode(_component_el_table_column, {
                label: "客户手机号",
                property: "customPhone"
              }),
              _createVNode(_component_el_table_column, {
                label: "入库时间",
                property: "createTime"
              }),
              _createVNode(_component_el_table_column, {
                label: "入库次数",
                property: "enterDbCount"
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                property: "status"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_pagination, {
            "current-page": page1.value.pageNo,
            "page-sizes": [5, 10, 20, 30, 40],
            "page-size": page1.value.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: dataCount.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentPageChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: linkCustFlag.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((linkCustFlag).value = $event)),
      width: "500",
      top: "1%",
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          model: formInline,
          "label-position": "left",
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "客户昵称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formInline.nickName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.nickName) = $event)),
                  placeholder: "请输入客户昵称",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (tipFlag.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "点击数据行即可关联unionId"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_table, {
            data: custItems.value,
            "highlight-current-row": "",
            onCurrentChange: handleCurrentChange,
            "empty-text": "数据量较大，请输入查询条件后查看！"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "头像",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_image, {
                    style: {"width":"100px","height":"100px"},
                    src: scope.row.avatar,
                    "preview-src-list": [scope.row.avatar],
                    "hide-on-click-modal": "true",
                    fit: "cover"
                  }, null, 8, ["src", "preview-src-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "昵称",
                property: "nickName"
              }),
              _createVNode(_component_el_table_column, {
                label: "主体",
                property: "corpName"
              }),
              _createVNode(_component_el_table_column, {
                label: "工作微信号",
                property: "wxAccount"
              }),
              _createVNode(_component_el_table_column, {
                label: "业务员",
                property: "empName"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_pagination, {
            "current-page": page.value.pageNo,
            "page-sizes": [5, 10, 20, 30, 40],
            "page-size": page.value.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: listCount.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentPageChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})